import React, { Component, Fragment } from "react";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";

import IntlMessages from "Util/IntlMessages";
import { injectIntl } from 'react-intl';
var classNames = require('classnames');
import StateButton from "Components/StateButton";

import {
    logoutUser
} from "Redux/actions";
import { connect } from "react-redux";

import API from '../../../api/index';
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import 'react-sortable-tree/style.css';
import CustomSelectInput from "Components/CustomSelectInput";
import { NotificationManager } from "Components/ReactNotifications";

import Select from "react-select";
import {
    Row,
    Button,
    FormGroup,
    Label,
    Input,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Col
} from "reactstrap";

import NumberFormat from 'react-number-format';
import { Colxx } from "Components/CustomBootstrap";
import IranStates from "Data/iran-states.json";
import IranCities from "Data/iran-cities.json";
import TehranZones from "Data/tehran-zones.json";
class CustomerAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ModalSaved: false,
            CustomerTagName:"",
            CustomerMobile: "",
            CustomerName: "",
            CustomerSurName: "",
            Gender: "none",
            HasBasicInfo: true,
            HasAddress: false,
            searchCustomer: {
                Name: "",
                SurName: "",
                Gender: "",
                ID: ""
            },
            Address: {
                State: {
                    label: "استان",
                    value: -1
                },
                City: {
                    label: "شهر",
                    value: -1
                },
                Zone: {
                    label: "محدوده",
                    value: -1
                },
                Gender: "none",
                Name: "",
                SurName: "",
                Mobile: "",
                Tel: "",
                PostCode: "",
                Address: ""
            },
        };
        this.handleChangeState = this.handleChangeState.bind(this);
        this.handleChangeCity = this.handleChangeCity.bind(this);
        this.handleChangeZone = this.handleChangeZone.bind(this);
        this.validateMobile = this.validateMobile.bind(this);
        this.lookupCustomer = this.lookupCustomer.bind(this);
        this.addressValidate = this.addressValidate.bind(this);
        this.validateSaveCustomer = this.validateSaveCustomer.bind(this);
        this.saveCustomer = this.saveCustomer.bind(this);

        this.loadData = this.loadData.bind(this);
        this.loadData();

    }

    loadData() {
        API.crm.customer.customerTagName({ CustomerTagID: this.props.match.params.customerTagID})
            .then(data => {
                (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                this.setState({
                    CustomerTagName: data.CustomerTagName,
                    isLoading: false
                });
            })
            .catch(error => { });
    }
    saveCustomer() {
        if (this.validateSaveCustomer()) {
            var orderData = {
                CustomerMobile: this.state.CustomerMobile,
                Name: this.state.CustomerName,
                SurName: this.state.CustomerSurName,
                Gender: this.state.Gender,
                HasAddress: this.state.HasAddress,
                Address: this.state.Address,
                CustomerTagID:this.props.match.params.customerTagID
            };
            orderData.Address.Name = this.state.CustomerName;
            orderData.Address.SurName = this.state.CustomerSurName;
            orderData.Address.Gender = this.state.Gender;
            orderData.Address.Mobile = this.state.CustomerMobile;

            this.setState({ isSaving: true });
            API.crm.customer.add(orderData)
                .then(data => {
                    (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;

                    if (data.ERRORS !== undefined) {
                        for (var i = 0; i < data.ERRORS.length; i++) {
                            setTimeout(function (err) {
                                NotificationManager.error(
                                    err,
                                    "خطا در ثبت مشتری ",
                                    8000, null, null, "filled");
                            }, (i + 1) * 700, data.ERRORS[i]);
                            this.setState({
                                isSaving: false
                            });
                        }
                    } else {
                        this.setState({
                            isSaving: false,
                            ModalSaved: true
                        });
                    }
                })
                .catch(error => { });
        }
    }
    validateSaveCustomer = () => {
        if (this.validateMobile(this.state.CustomerMobile) && this.state.searchCustomer.ID == "") {
            if (this.state.HasAddress) {
                if (this.addressValidate("FULLADDRESS")) {
                    return true;
                }
            } else {
                return true;
            }
        }
        return false;
    }
    handleChangeState = (state) => {
        var _Address = this.state.Address;
        _Address.State = state;
        this.setState({ Address: _Address });
    }

    handleChangeCity = (city) => {
        var _Address = this.state.Address;
        _Address.City = city;
        this.setState({ Address: _Address });
    }

    handleChangeZone = (zone) => {
        var _Address = this.state.Address;
        _Address.Zone = zone;
        this.setState({ Address: _Address });
    }
    validateMobile(mobile) {
        if (mobile.trim() == "") {
            return false;
        }
        return mobile.match(/^(0)+(9|$)\d{9}$/g) != null;
    }
    addressValidate(section) {
        if (section == "ALL" || section == "FULLADDRESS" || section == "STATE") {
            if (this.state.Address.State.value == -1) {
                return false;
            }
        }

        if (section == "ALL" || section == "FULLADDRESS" || section == "CITY") {
            if (this.state.Address.City.value == -1) {
                return false;
            }
        }


        if (section == "ALL" || section == "FULLADDRESS" || section == "ZONE") {
            if (this.state.Address.City.value == 301 && this.state.Address.State.value == 8 && this.state.Address.Zone.value == -1) {
                return false;
            }
        }

        if (section == "ALL" || section == "FULLADDRESS" || section == "ADDRESS") {
            if (this.state.Address.Address.length < 5) {

                return false;
            }
        }

        if (section == "ALL" || section == "MOBILE") {
            if (this.state.Address.Mobile.length != "09121281022".length || this.state.Address.Mobile.match(/^(0)+(9|$)\d{9}$/g) == null) {
                return false;
            }
        }

        return true;
    }
    cleanCustomerMobile(mobile) {
        mobile = mobile.split(" ").join("");
        mobile = mobile.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

        // console.log(mobile,mobile.indexOf("0098"))
        if (mobile.indexOf("0098") === 0) {
            mobile = mobile.replace("0098", "0");
        }
        if (mobile.indexOf("098") === 0) {
            mobile = mobile.replace("098", "0");
        }
        if (mobile.indexOf("+98") === 0) {
            mobile = mobile.replace("+98", "0");
        }
        if (mobile.indexOf("98") === 0) {
            mobile = mobile.replace("98", "0");
        }
        if (mobile.indexOf("9") === 0 && mobile.length == 10) {
            mobile = "0" + mobile;
        }
        return mobile;
    }
    lookupCustomer(mobile) {

        if (this.validateMobile(mobile)) {

            API.order.new.lookupCustomer({ CustomerMobile: mobile })
                .then(data => {
                    (data.RELOGIN) ? this.props.logoutUser(this.props.history) : 0;
                    if (data.CUSTOMER !== undefined) {
                        this.setState({ searchCustomer: data.CUSTOMER });
                    } else {
                        this.setState({
                            searchCustomer: {
                                Name: "",
                                SurName: "",
                                Gender: "",
                                ID: ""
                            }
                        });
                    }
                })
                .catch(error => {
                    this.setState({
                        searchCustomer: {
                            Name: "",
                            SurName: "",
                            Gender: "",
                            ID: ""
                        }
                    });
                });
        } else {
            this.setState({
                searchCustomer: {
                    Name: "",
                    SurName: "",
                    Gender: "",
                    ID: ""
                }
            });
        }
    }
    render() {
        return (
            this.state.isLoading ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row className="mb-4">
                        <Colxx xxs="3"></Colxx>
                        <Colxx xxs="6">
                            <Card>
                                <CardBody>
                                    <CardTitle>
                                        <div className={"iconsminds-add-user headingicon"} />
                                         ثبت مشتری با برچسب :   <strong style={{ textDecoration: "underline" }}>{this.state.CustomerTagName}</strong>
                                    </CardTitle>

                                    <Row className="mb-4">

                                        <Colxx sm={6}>
                                            <FormGroup className={"filter " + ((this.validateMobile(this.state.CustomerMobile)) ? ((this.state.searchCustomer.ID == "") ? "filter-active" : "filter-error") : "")}>
                                                ‌{this.state.searchCustomer.ID != "" ? (
                                                    <a href={"/app/customers/view-customer/" + this.state.CustomerMobile} target="_blank"
                                                        className={classNames({
                                                            "iconsminds-business-man": (this.state.searchCustomer.Gender == "MALE") ? true : false,
                                                            "iconsminds-business-woman": (this.state.searchCustomer.Gender == "FEMALE") ? true : false,
                                                            "headingicon": true
                                                        })}>
                                                        {this.state.searchCustomer.Name} {this.state.searchCustomer.SurName} #{this.state.searchCustomer.ID}
                                                    </a>
                                                ) : (
                                                    <Label for="CustomerMobile">
                                                        {(this.validateMobile(this.state.CustomerMobile)) ? (
                                                            <span> مشتری جدید*</span>
                                                        ) : (
                                                            <span> موبایل مشتری</span>
                                                        )}
                                                    </Label>
                                                )}

                                                <Input
                                                    autoComplete="off"
                                                    type="text"
                                                    name="CustomerMobile"
                                                    id="CustomerMobile"
                                                    disabled={this.state.isSaving}
                                                    placeholder=""
                                                    value={this.state.CustomerMobile}
                                                    onChange={(e) => { var cleanValue = this.cleanCustomerMobile(e.target.value); this.setState({ CustomerMobile: cleanValue }); this.lookupCustomer(cleanValue) }}

                                                />
                                            </FormGroup>
                                        </Colxx>
                                        <Colxx sm={12}>
                                            <FormGroup className={"filter "} >
                                                <Row>

                                                    <Colxx xxs="4">

                                                        <div onClick={() => { if (this.state.isSaving) { return; }; this.setState({ Gender: this.state.Gender == "FEMALE" ? "none" : "FEMALE" }); }} className={classNames({ "gender-toggle": true, "gender-selectted": this.state.Gender == "FEMALE" })} style={{ display: "inline-block", float: "left", width: "80px", "marginRight": "5px" }} >
                                                            <i className={"iconsminds-business-woman"} ></i>&nbsp;
                                                            خانم
                                                        </div>
                                                        <div onClick={() => { if (this.state.isSaving) { return; }; this.setState({ Gender: this.state.Gender == "MALE" ? "none" : "MALE" }); }} className={classNames({ "gender-toggle": true, "gender-selectted": this.state.Gender == "MALE" })} style={{ display: "inline-block", float: "left", width: "80px" }} >
                                                            <i className={"iconsminds-business-man"} ></i>&nbsp;
                                                            آقای
                                                        </div>
                                                    </Colxx>
                                                    <Colxx xxs="6">
                                                        <Input
                                                            autoComplete="off"
                                                            type="text"
                                                            name="CustomerMobile"
                                                            id="CustomerMobile"
                                                            placeholder="نام"
                                                            disabled={this.state.isSaving}
                                                            style={{ "display": "inline-block", "width": "calc(50% - 5px)", "marginLeft": "5px" }}
                                                            value={this.state.CustomerName}
                                                            onChange={(e) => { this.setState({ CustomerName: e.target.value }); }}
                                                        />

                                                        <Input
                                                            autoComplete="off"
                                                            type="text"
                                                            name="CustomerMobile"
                                                            id="CustomerMobile"
                                                            disabled={this.state.isSaving}
                                                            style={{ "display": "inline-block", "width": "calc(50% - 5px)" }}
                                                            placeholder="نام خانوادگی"
                                                            value={this.state.CustomerSurName}
                                                            onChange={(e) => { this.setState({ CustomerSurName: e.target.value }); }}

                                                        />
                                                    </Colxx>
                                                    <Colxx xxs="2">
                                                        <label>
                                                            آدرس
                                                        </label>
                                                        <Switch
                                                            disabled={this.state.isSaving}
                                                            className="custom-switch custom-switch-primary"
                                                            checked={this.state.HasAddress}
                                                            onChange={HasAddress => {
                                                                this.setState({ HasAddress });
                                                            }}
                                                        />
                                                    </Colxx>
                                                </Row>


                                            </FormGroup>
                                        </Colxx>
                                        {this.state.HasAddress ?
                                            <Colxx xxs="12">
                                                <FormGroup className={"filter formgroup-address"} >
                                                    <Row style={{ "padding": "10px" }}>
                                                        <Colxx xxs="12" md="6" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                                            <Select
                                                                components={{ Input: CustomSelectInput }}
                                                                className={classNames({
                                                                    "react-select": true,
                                                                    "filed-border-error": !this.addressValidate("STATE")
                                                                })}
                                                                classNamePrefix="react-select"
                                                                id="AddressState"
                                                                value={this.state.Address.State}
                                                                disabled={this.state.isSaving}
                                                                onChange={this.handleChangeState}
                                                                options={IranStates}
                                                            />
                                                        </Colxx>
                                                        <Colxx xxs="12" md="6" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                                            <Select
                                                                components={{ Input: CustomSelectInput }}
                                                                className={classNames({
                                                                    "react-select": true,
                                                                    "filed-border-error": !this.addressValidate("CITY")
                                                                })}
                                                                classNamePrefix="react-select"
                                                                id="AddressCity"
                                                                disabled={this.state.isSaving}
                                                                value={this.state.Address.City}
                                                                onChange={this.handleChangeCity}
                                                                options={IranCities.filter((row => {
                                                                    return (row.state == this.state.Address.State.value);
                                                                }))}
                                                            />
                                                        </Colxx>
                                                        <Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="6">
                                                            <Input
                                                                autoComplete="off"
                                                                type="text"
                                                                name="reciverPostCode"
                                                                disabled={this.state.isSaving}
                                                                id="reciverPostCode"
                                                                placeholder="کد پستی (اختیاری)"
                                                                value={this.state.Address.PostCode}
                                                                onChange={(e) => { var tmpObj = { ...this.state.Address }; tmpObj.PostCode = e.target.value; this.setState({ Address: tmpObj }); }}
                                                            />
                                                        </Colxx>
                                                        {this.state.Address.State.value == 8 && this.state.Address.City.value == 301 ?
                                                            <Colxx xxs="12" md="6" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                                                <Select
                                                                    components={{ Input: CustomSelectInput }}
                                                                    className={classNames({
                                                                        "react-select": true,
                                                                        "filed-border-error": !this.addressValidate("ZONE")
                                                                    })}
                                                                    disabled={this.state.isSaving}
                                                                    classNamePrefix="react-select"
                                                                    id="AddressCity"
                                                                    value={this.state.Address.Zone}
                                                                    onChange={this.handleChangeZone}
                                                                    options={TehranZones}
                                                                />
                                                            </Colxx>
                                                            : false}

                                                        <Colxx xxs="12" md="12" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                                            <textarea
                                                                className={"validateable-input"}
                                                                style={{ width: "100%", border: "1px solid lightgray", padding: "10px", border: (this.addressValidate("ADDRESS") ? "1px solid lightgray" : "1px solid red") }}
                                                                placeholder="آدرس کامل با طبقه و پلاک و ..."
                                                                disabled={this.state.isSaving}
                                                                value={this.state.Address.Address}
                                                                onChange={(e) => { var tmpObj = { ...this.state.Address }; tmpObj.Address = e.target.value; this.setState({ Address: tmpObj }); }}
                                                                rows="2" />
                                                        </Colxx>


                                                        <Colxx xxs="6" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="2">
                                                            <div className={classNames({ "gender-toggle": true, "gender-selectted": this.state.Gender == "MALE" })} style={{ display: "inline-block", float: "left", backgroundColor: "#e9ecef", color: "gray" }} >
                                                                <i className={"iconsminds-business-man"} ></i>&nbsp;
                                                                آقای
                                                            </div>
                                                        </Colxx>
                                                        <Colxx xxs="6" style={{ paddingLeft: "5px", paddingRight: "0px" }} md="2">
                                                            <div className={classNames({ "gender-toggle": true, "gender-selectted": this.state.Gender == "FEMALE" })} style={{ display: "inline-block", float: "left", backgroundColor: "#e9ecef", color: "gray" }} >
                                                                <i className={"iconsminds-business-woman"} ></i>&nbsp;
                                                                خانم
                                                            </div>
                                                        </Colxx>

                                                        <Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="4">
                                                            <Input
                                                                autoComplete="off"
                                                                type="text"
                                                                name="reciverName"
                                                                className={"validateable-input"}
                                                                id="reciverName"
                                                                value={this.state.CustomerName}
                                                                disabled={true}
                                                            />
                                                        </Colxx>
                                                        <Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="4">
                                                            <Input
                                                                autoComplete="off"
                                                                type="text"
                                                                name="reciverSurName"
                                                                className={"validateable-input"}
                                                                id="reciverSurName"
                                                                value={this.state.CustomerSurName}
                                                                disabled={true}
                                                            />
                                                        </Colxx>
                                                        <Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="6">
                                                            <Input
                                                                autoComplete="off"
                                                                type="text"
                                                                name="reciverMobile"
                                                                id="reciverMobile"
                                                                className={"validateable-input"}
                                                                value={this.state.CustomerMobile}
                                                                disabled={true}
                                                            />
                                                        </Colxx>
                                                        <Colxx xxs="12" style={{ paddingLeft: "5px", paddingRight: "5px" }} md="6">
                                                            <Input
                                                                autoComplete="off"
                                                                type="text"
                                                                name="reciverTel"
                                                                id="reciverTel"
                                                                placeholder="تلفن ثابت (اختیاری)"
                                                                disabled={this.state.isSaving}
                                                                value={this.state.Address.Tel}
                                                                onChange={(e) => { var tmpObj = { ...this.state.Address }; tmpObj.Tel = e.target.value; this.setState({ Address: tmpObj }); }}
                                                            />
                                                        </Colxx>
                                                    </Row>
                                                </FormGroup>
                                            </Colxx>
                                            : <div />}

                                        <Colxx xxs="12">
                                            <FormGroup className={"filter "} >
                                                <Row style={{ "padding": "10px" }}>

                                                    <Colxx xxs="12" style={{ "textAlign": "right" }}>
                                                        ایجاد سفارش به مبلغ
                                                        <Input
                                                            autoComplete="off"
                                                            type="text"
                                                            name="OrderPrice"
                                                            id="CustomerMobile"
                                                            placeholder=""
                                                            value={0}
                                                            disabled={true}
                                                            style={{ "width": "40px", "display": "inline-block", "marginLeft": "5px", "marginRight": "5px", "textAlign": "center" }}

                                                        />
                                                        تومان به تاریخ

                                                        <Input
                                                            autoComplete="off"
                                                            type="text"
                                                            name="OrderDate"
                                                            id="CustomerMobile"
                                                            placeholder=""
                                                            value="1399/01/01"
                                                            disabled={true}
                                                            style={{ "width": "90px", "display": "inline-block", "marginLeft": "5px", "marginRight": "5px", "textAlign": "center" }}

                                                        />
                                                    </Colxx>
                                                </Row>
                                            </FormGroup>
                                        </Colxx>
                                        <Colxx xxs="12">
                                            <FormGroup className={"filter "} >
                                                <Row style={{ "padding": "10px" }}>


                                                    <Colxx xxs="12">
                                                        الصاق برچسب به مشتری

                                                        <Select
                                                            components={{ Input: CustomSelectInput }}
                                                            className="react-select"
                                                            classNamePrefix="react-select"
                                                            isMulti
                                                            name="form-field-name"
                                                            value={{ label: this.state.CustomerTagName, value: "", key: 0 }}
                                                            disabled={true}
                                                            // onChange={this.handleChangeMulti}
                                                            options={[
                                                                { label: this.state.CustomerTagName, value: "", key: 0 },
                                                            ]}
                                                        />
                                                    </Colxx>
                                                </Row>
                                            </FormGroup>
                                        </Colxx>
                                        <Colxx xxs="12">
                                            <Button color="primary" className="default mb-2 btn-shadow" style={{ "float": "left" }} disabled={this.state.isSaving || !this.validateSaveCustomer()} onClick={(e) => { this.saveCustomer() }}>
                                                ثبت مشتری
                                            </Button>
                                            {" "}
                                            <div className="loading loading-inline" style={{ display: this.state.isSaving ? "inline-block" : "none", "marginLeft": "5px" }}></div>

                                            <Modal isOpen={this.state.ModalSaved}>
                                                <ModalHeader>
                                                    مشتری با برچسب 
                                                    {" "}
                                                    <strong style={{ textDecoration: "underline" }}>{this.state.CustomerTagName}</strong>
                                                    {" "}
                                                     با موفقیت ثبت شد.
                                                </ModalHeader>
                                                <ModalFooter>

                                                    <Button color="light" className="default mb-2" onClick={() => { window.open('/app/customers/view-customer/' + this.state.CustomerMobile) }}>
                                                        <div className={"iconsminds-business-man-woman headingicon"} />
                                                        مشاهده کاربر
                                                    </Button>{" "}
                                                    <Button color="primary" className="default mb-2" onClick={() => { window.location.reload() }}>
                                                        <div className={"simple-icon-reload headingicon"} />
                                                        ثبت جدید
                                                    </Button>{" "}
                                                </ModalFooter>
                                            </Modal>
                                        </Colxx>
                                    </Row>
                                </CardBody>
                            </Card>

                        </Colxx>

                    </Row>
                </Fragment>
        );
    }
}


const mapStateToProps = ({ menu, settings }) => {
    return { logoutUser };
};
export default injectIntl(connect(
    mapStateToProps,
    { logoutUser }
)(CustomerAdd));
// export default injectIntl(ProductPriceManager);